import { fetchOperators } from "../../services/operatorsService";
import {
  fetchCityOperator,
  operatorsFetched,
} from "../actions/operatorsAction";
import {
  showLoading,
  hideLoading,
  resetLoading,
} from "../../shared/widgets/bar-loader/src";
import { createAllActionCreators } from "./actionCreatorUtil";

export const cityOperatorsListAction = (params, loaderScope) => (dispatch) => {
  dispatch(resetLoading(loaderScope));
  dispatch(showLoading(loaderScope));
  dispatch(fetchCityOperator(params));
  dispatch(hideLoading(loaderScope));
};

const operatorActionCreators = {
  createOperatorsListAction: {
    service: fetchOperators,
    action: operatorsFetched,
    customApiResponse: (response) => {
      const header = {
        uniqId: "promoter",
        operatorName: "promoter",
        displayName: "Promoter",
        operatorId: "promoter",
      };
      response.push(header);
      return response;
    },
  },
};

export const { createOperatorsListAction } = createAllActionCreators(
  operatorActionCreators,
);
